<template>
    <div @click.stop="$parent.$parent.onEditer(index)" class="tabbar">
      <div class="drag optional" :class="{selected:index === selectedIndex}" style="width:100%;">
        <div class="diy-tabBar" :style="{background:item.style.background}">
          <ul class="list" :class="'column-'+item.style.rowsNum">
            <li class="item" :key="index" v-for="(tabBar,index) in item.data" :class="tabBar.style == 'stand_out'?'stand_out':''">
              <div class="item-image" v-if="Number(tabBar.icon_type) === 20">
                <img v-img-url="tabBar.imgUrl">
              </div>
              <div class="icon-box" v-else>
                <i :class="tabBar.icon"></i>
              </div>
              <div class="item-text text-ellipsis" :style="{color:tabBar.color}">
                {{tabBar.text}}</div>
            </li>
          </ul>
        </div>
        <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    props: ['item', 'index', 'selectedIndex'],
    methods: {

    }
  };
</script>

<style lang="scss" scoped>
@import '../../../../../components/page/static/iconfont2.css';
.stand_out {
  position: relative;
  bottom: 30px;
  padding: 0 !important;
}
.stand_out img {
  width: 50px !important;
  height: 50px !important;
}

.stand_out .item-text{
  position: relative;
  top:17px;
}
.stand_out .item-image{
  position: relative;
  top: 10px;
}
.diy-tabBar,.drag{
  height: 55px;
}
.tabbar{position: absolute !important;display: flex;bottom: 0;width: 100%;overflow: auto;white-space: nowrap;}
/* .diy-tabBar .list{ display: flex; flex-wrap: wrap; align-items: flex-start;} */
.diy-tabBar .list{ display: flex; justify-content: space-around; align-items: center;height: 55px;}
/* .diy-tabBar .list .item{ padding: 10px 0; display: flex; justify-content: center; align-items: center; flex-direction: column;} */
.diy-tabBar .list .item{display: flex; justify-content: center; align-items: center; flex-direction: column;}
.diy-tabBar .list.column-3 .item{ width: 33.333333333%;}
.diy-tabBar .list.column-4 .item{ width: 25%;}
.diy-tabBar .list.column-5 .item{ width: 20%;}

.diy-tabBar .list .item-image img{ position: relative;display: inline-block;margin-top: 5px;width: 24px;height: 24px;}
.diy-tabBar .list .item-text{  position: relative;text-align: center;line-height: 1.8;font-size: 5px;}

.icon-box {
  width: 30px;
  height: 30px;
  display: inline-block;
  text-align: center;
  i {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/model/TabBar.vue